enum SavingsAgreementFrequency {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  SIX_MONTHS = 'SIX_MONTHS',
  TERTIARLY = 'TERTIARLY',
  TWO_MONTHS = 'TWO_MONTHS',
  THREE_MONTHS = 'THREE_MONTHS',
  FOUR_MONTHS = 'FOUR_MONTHS',
  ANNUAL = 'ANNUAL',
}

export default SavingsAgreementFrequency;
